//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SourceBase from '../source-common-module/source-base';
import SourceStageLog from '../source-common-module/source-stage-log';
import SourceMaterial from '../source-common-module/source-material';
import SourceSup from '../source-common-module/source-sup';
import SourceOffer from '../source-common-module/source-offer';
import SourceBusiness from '../source-common-module/source-business';
import SourceAttach from '../source-common-module/source-attach';
import SourceNotice from '../source-common-module/source-notice';
import SourceQuestion from '../source-common-module/source-question';
export default {
  name: "source-item-view",
  components:{
    SourceBase,
    SourceStageLog,
    SourceMaterial,
    SourceSup,
    SourceOffer,
    SourceBusiness,
    SourceAttach,
    SourceNotice,
    SourceQuestion
  },
  data(){
    return{
      sourceId: null,
      sourceDto:{},
      selectModel:'base',
      defaultPar:{},
      priceTemplateList:[],
      rotation:{},
      operShow:false,
      menus:[{label:'中止项目',value: 'end'}],
      current:{},
      sourceExtendConfig:{}
    }
  },
  methods:{
    backSourceList(){
      this.$router.go(-1);
    },
    getSourceDto(){
      this.$loadingShow();
      this.$get(`api/source/${this.sourceId}`).then((res) => {
        if(res){
          this.sourceDto = res;
          if(!(this.sourceDto.status === 'approvalReturn' || this.sourceDto.status === 'draft' || this.sourceDto.status === 'inApproval')){
            this.selectModel = 'stageLog';
          }
          this.sourceDto.sourceRotationList = this.sourceDto.sourceRotationList.sort((a,b) => a.round - b.round);
          this.priceTemplateList = (this.sourceDto.priceTemplete && this.sourceDto.priceTemplete.sptQuoteFieldList) || [];
          this.priceTemplateList.sort((a, b) => a.sort - b.sort);
          if(this.sourceDto.sourceRotationList[this.sourceDto.currentRound-1]){
            this.rotation = this.sourceDto.sourceRotationList[this.sourceDto.currentRound-1];
          }
          this.getDefault();
          this.getSourceExtendConfig();
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    getDefault(){
      if(this.sourceDto.sourceType){
        this.$loadingShow();
        this.$get(`api/sourceType/${this.sourceDto.sourceType.id}`).then((res) => {
          for(let k in res){
            if(res[k] && res[k].defaultValue){
              if(res[k].defaultValue === 'true'){
                res[k].defaultValue = true;
              }else if(res[k].defaultValue === 'false'){
                res[k].defaultValue = false;
              }
            }
          }
          this.defaultPar = res;
          this.copyTemplateToDefaultPar();
          this.$loadingHide();
        }).catch(() => {
          this.$loadingHide();
        })
      }
    },
    copyTemplateToDefaultPar(){
      this.defaultPar.materialType = this.sourceDto.priceTemplete.materialType;
      this.defaultPar.demandQuantity = this.sourceDto.priceTemplete.demandQuantity;
      this.defaultPar.baseUnit = this.sourceDto.priceTemplete.baseUnit;
      this.defaultPar.matPlant = this.sourceDto.priceTemplete.matPlant;
      this.defaultPar.matDemandDate = this.sourceDto.priceTemplete.matDemandDate;
      this.defaultPar.matPurchaseNum = this.sourceDto.priceTemplete.matPurchaseNum;
      this.defaultPar.matRemark = this.sourceDto.priceTemplete.matRemark;
      this.defaultPar.matAttach = this.sourceDto.priceTemplete.matAttach;
    },
    changeShowModel(str){
      this.selectModel = str;
    },
    operation(){
      this.operShow = true;
    },
    clickMenu(e){
      if(e === 'end'){
        this.$vux.confirm.show(
          {
            title:'确认中止该寻源项目',
            onConfirm:() => {
              this.$loadingShow();
              this.$get(`api/source/give-up`,{id:this.sourceId}).then((res) => {
                this.$vux.toast.text('已中止该寻源项目');
                this.$loadingHide();
                this.getSourceDto();
              }).catch(() => {
                this.$loadingHide();
              })
            }
          }
        )
      }
    },
    getCurrent(){
      this.$get('api/person/current').then((res) => {
        if(res){
          this.current = res;
        }
      })
    },
    /**
     * 获取寻源项目扩展字段配置
     * */
    getSourceExtendConfig(){
      if(this.sourceDto && this.sourceDto.priceTemplete && this.sourceDto.priceTemplete.matExtendCode){
        this.$get(`api/biz-table/${this.sourceDto.priceTemplete.matExtendCode}/activated-field`).then((res) => {
          if(res && res.dynamicTables && res.dynamicTables[0]){
            this.sourceExtendConfig = res.dynamicTables[0];
          }
        })
      }
    }
  },
  mounted(){
    this.sourceId = this.$route.params.id;
    this.getSourceDto();
    this.getCurrent();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-item/source-item-view.vue